import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Wifi } from 'lucide-react';
import api from '../utils/api';
import IspLinksWidget from './IspLinksWidget';

// Self-populating "Enlaces de Internet" strip for the internal agent Dashboard.
// Uses the company-scoped /api/monitor/assets, so a scoped agent (Ezequiel/Beto
// → Papelera) sees only their companies' ISP links, admins see all, and it
// renders nothing when there's no ISP link in scope. Click → Monitor detail.
export default function IspLinksDashboardStrip() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [links, setLinks] = useState([]);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const load = () => api.get('/monitor/assets?asset_type=isp_connection&limit=200')
      .then(({ data }) => { if (!cancelled) setLinks(data?.assets || []); })
      .catch(() => {})
      .finally(() => { if (!cancelled) setReady(true); });
    load();
    const iv = setInterval(load, 60000);
    return () => { cancelled = true; clearInterval(iv); };
  }, []);

  if (!ready || !links.length) return null;

  return (
    <div style={{ marginBottom: 16 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
        <Wifi size={15} style={{ color: 'var(--c-brand)' }} />
        <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--c-text-muted)', textTransform: 'uppercase', letterSpacing: 0.5 }}>
          {t('companies.internetLinks')}
        </span>
      </div>
      <IspLinksWidget
        links={links}
        groupByCompany
        onLinkClick={(id) => navigate(`/monitor/${id}`)}
        onCompanyClick={(cid) => navigate(`/companies?id=${cid}`)}
        onViewAll={() => navigate('/monitor')}
      />
    </div>
  );
}
